export const sectionTitleSx = {
    fontWeight: 800,
    mb: 1.25,
    color: "#0f172a",
    letterSpacing: "-0.02em",
    fontSize: { xs: "1.6rem", md: "2rem" },
    lineHeight: 1.15,
};

export const sectionSubtitleSx = {
    maxWidth: 820,
    color: "#475569",
    fontSize: { xs: "0.98rem", md: "1.03rem" },
    lineHeight: 1.75,
    mx: "auto",
};

export const cardSx = {
    height: "100%",
    borderRadius: 4,
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.08)",
    border: "1px solid rgba(148, 163, 184, 0.18)",
    transition: "transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease",
    "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 18px 40px rgba(15, 23, 42, 0.12)",
        borderColor: "rgba(37, 99, 235, 0.22)",
    },
};